module.exports = __webpack_public_path__ + "img/ps-52.57132e91.jpg";